export interface TabItem {
  value: string;
  label: string;
}

export function Tabs({ items = [], active, onChange }: { items?: TabItem[]; active?: string; onChange?: (v: string) => void }) {
  return (
    <div style={{ display: 'flex', borderBottom: '1px solid var(--border-default)', gap: 4 }}>
      {items.map((it) => (
        <button
          key={it.value}
          onClick={() => onChange?.(it.value)}
          style={{
            fontFamily: 'var(--font-vi)',
            fontSize: 14,
            fontWeight: 600,
            padding: '10px 16px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            color: active === it.value ? 'var(--cta-default)' : 'var(--text-secondary)',
            borderBottom: active === it.value ? '2px solid var(--cta-default)' : '2px solid transparent',
          }}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
